export const AUSTRALIA_COUNTRY_NAME = 'Australia';

export const THEMES = {
  STUDY_AUS: 'studyaus',
  STUDY_MELB: 'studymelb',
  STUDY_QLD: 'studyqld'
};

export const EVENT = {
  ACIR_SEARCH_BUTTON_CLICKED: 'acir_search_button_clicked',
  ACIR_COURSE_PROFILE_LOADED: 'acir_course_profile_loaded',
};